import React, { useState } from "react";
import data from "./data";

function List() {
  const [people, setPeople] = useState(data);

  function deleteItem(id) {
    setPeople(people.filter((person) => person.id !== id));
  }

  function clearAll() {
    setPeople([]);
  }

  console.log(people);
  return (
    <main>
      <section className="container">
        <h3>{people.length ? people.length : 0} birthdays today.</h3>
        {people.map((person) => (
          <div key={person.id}>
            <article className="person">
              <img src={person.image} />
              <div>
                <h4>{person.name}</h4>
                <p>{person.age}</p>
              </div>
              <a onClick={() => deleteItem(person.id)} className="delete">
                Delete
              </a>
            </article>
          </div>
        ))}
        <button onClick={clearAll} className="btn">
          Clear all
        </button>
      </section>
    </main>
  );
}

export default List;
